module.exports = __webpack_public_path__ + "static/media/ogs2.png.c0e75e88.jpg";